import { render, staticRenderFns } from "./MovieContentsTexts.vue?vue&type=template&id=8afa4448&scoped=true&"
import script from "./MovieContentsTexts.vue?vue&type=script&lang=ts&"
export * from "./MovieContentsTexts.vue?vue&type=script&lang=ts&"
import style0 from "./MovieContentsTexts.vue?vue&type=style&index=0&id=8afa4448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afa4448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
